import { useMutation } from "react-query";
import api from "../../client";
import { InstitutionMergePayload } from "../../types/institution";

const postData = async (payload: InstitutionMergePayload): Promise<any> => {
  const { data } = await api.post(`/institutions/merge`, payload);

  return data;
};

export const useMergeInstitutions = () => {
  return useMutation((payload: InstitutionMergePayload) => {
    return postData(payload);
  });
};
